import * as React from "react";
import theme from "styles/theme";
import { ImageIcon } from "components/icons/assortments/image";
import { formatMessage } from "lib/globalize-util";
import { merge, $, media } from "glamor";
import { DATATEST } from "constants/integration";
import { IShopViewSettings, IShopViewSettingsValue } from "./types";

const styles = merge(
    {
        width: "380px !important",
        paddingRight: "80px",
    },
    $(" .imageContainer", {
        border: `2px solid ${theme.palette.borderColor}`,
    }),
    $(" .noImageIcon", {
        height: "200px !important",
        width: "120px !important",
        display: "block !important",
        margin: "0 auto",
        color: `${theme.palette.grey} !important`,
    }),
    $(" .detailsContainer", {
        margin: "4px 0 16px",
        color: theme.palette.tileItemText,
    }),
    $(" .detailsContainer .bold", {
        fontSize: "12px",
        fontWeight: "bold",
        color: theme.palette.textColor,
    }),
    $(" .detailsContainer p", {
        margin: 0,
        fontSize: "10px",
        letterSpacing: "0.15px",
        lineHeight: "16px",
    }),
    $(" .totalsContainer", {
        boxShadow: `0 1px 0 0 ${theme.palette.tileItemShadowColor}`,
        paddingBottom: "8px",
    }),
    $(" .totalsContainer p", {
        margin: 0,
        color: theme.palette.darkGrey,
        fontSize: "10px",
        letterSpacing: "0.15px",
        lineHeight: "16px",
        fontWeight: "bold",
    }),
    $(" .colorContainer", {
        display: "flex",
        alignItems: "center",
    }),
    $(" .colorContainer span", {
        lineHeight: "22px",
        fontSize: "11px",
    }),
    $(" .colorSwatch", {
        width: "22px",
        height: "22px",
        borderRadius: "50%",
        border: `solid 1px ${theme.palette.swatchBorderColor}`,
        marginRight: "4px",
        backgroundColor: theme.palette.swatchBackgroundColor,
    }),
    media("(max-width: 768px)", {
        width: "250px !important",
        margin: "0 auto 20px",
        paddingRight: 0,
    }),
    media("(max-width: 600px)", {
        width: "220px !important",
    }),
    media("(max-width: 440px)", {
        width: "200px !important",
    })
);
interface IProps {
    settings: IShopViewSettings;
    settingsValue: IShopViewSettingsValue;
}

export const PreviewPanelView: React.FunctionComponent<IProps> = ({ settings, settingsValue }) => (
    <div {...styles}>
        <div className="imageContainer">
            <ImageIcon className="noImageIcon" />
        </div>
        <div className="detailsContainer">
            {settings.firstLine && (
                <p data-test={DATATEST.ASSORTMENTS.SHOP.SETTINGS.MODAL.PREVIEW.FIRST_LINE}>
                    {settingsValue[settings.firstLine]}
                </p>
            )}
            {settings.secondLine && (
                <p data-test={DATATEST.ASSORTMENTS.SHOP.SETTINGS.MODAL.PREVIEW.SECOND_LINE} className="bold">
                    {settingsValue[settings.secondLine]}
                </p>
            )}
            {settings.thirdLine && (
                <p data-test={DATATEST.ASSORTMENTS.SHOP.SETTINGS.MODAL.PREVIEW.THIRD_LINE}>
                    {settingsValue[settings.thirdLine]}
                </p>
            )}
            <div className="colorContainer">
                {settings.fourthLine && (
                    <span data-test={DATATEST.ASSORTMENTS.SHOP.SETTINGS.MODAL.PREVIEW.FOURTH_LINE}>
                        {settingsValue[settings.fourthLine]}
                    </span>
                )}
            </div>
        </div>
        <div className="totalsContainer">
            {settings.showCost && (
                <p data-test={DATATEST.ASSORTMENTS.SHOP.SETTINGS.MODAL.PREVIEW.SHOW_COST}>
                    {formatMessage("Cost (ea)")}
                </p>
            )}
            {settings.showRetail && (
                <p data-test={DATATEST.ASSORTMENTS.SHOP.SETTINGS.MODAL.PREVIEW.SHOW_RETAIL}>
                    {formatMessage("Retail (ea)")}
                </p>
            )}
        </div>
    </div>
);
